import { createFileRoute, useCanGoBack, useNavigate, useRouter } from '@tanstack/react-router';
import { ManageGroup } from '@/components/manage-group';

export const Route = createFileRoute('/_app/account_/groups_/$id')({ component: ManageGroupPage });

/** Account › My groups › a group: Manage group, with Back. */
function ManageGroupPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const router = useRouter();
  const canGoBack = useCanGoBack();
  // Opened from a link there is nothing behind it: fall back to My groups.
  const back = () =>
    canGoBack ? router.history.back() : void navigate({ to: '/account/groups', replace: true });
  return <ManageGroup id={id} onBack={back} />;
}
